import { render, staticRenderFns } from "./BasicTree.vue?vue&type=template&id=2a696538&scoped=true"
import script from "./BasicTree.vue?vue&type=script&lang=js"
export * from "./BasicTree.vue?vue&type=script&lang=js"
import style0 from "./BasicTree.vue?vue&type=style&index=0&id=2a696538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a696538",
  null
  
)

export default component.exports